import React, { ReactNode } from 'react';
import {
    Flex,
    ListItem,
    List as ChakraList,
    FlexProps,
    ListItemProps,
    Text
} from '@chakra-ui/react';
import { ReactElement, PropsWithChildren } from 'react';

export const List: React.FC<{
    spacing?: string;
    children?: React.ReactNode;
}> = ({ spacing = '2', children }) => {
    return <ChakraList marginBottom={spacing}>{children}</ChakraList>;
};

export const ListRow = ({
    children,
    ...rest
}: PropsWithChildren<ListItemProps>): ReactElement => {
    return (
        <ListItem mb="2" display="flex" {...rest}>
            {children}
        </ListItem>
    );
};

export const ListRowLabel = ({
    children,
    ...rest
}: PropsWithChildren<FlexProps>): ReactElement => {
    return (
        <Flex
            color="gray.600"
            width="200px"
            fontWeight="500"
            fontSize="sm"
            {...rest}>
            {children}
        </Flex>
    );
};

export const ListRowValue = ({
    children,
    ...rest
}: PropsWithChildren<FlexProps>): ReactElement => {
    if (!children) {
        return (
            <Flex flex="1" {...rest}>
                <Text color="disabled" fontSize="sm" fontWeight="600">
                    No data
                </Text>
            </Flex>
        );
    }
    return (
        <Flex fontSize="sm" flex="1" fontWeight="600" {...rest}>
            {children}
        </Flex>
    );
};

export const ListRowItem = ({
    label,
    value,
    ...rest
}: {
    label: string;
    value: string | number | ReactNode;
}) => {
    return (
        <ListRow {...rest}>
            <ListRowLabel>{label}</ListRowLabel>
            <ListRowValue justify="flex-end">{value}</ListRowValue>
        </ListRow>
    );
};
